export type InboundAndReturnFrequency = {
  text: string;
  value: number;
};

export const inboundAndReturnFrequencies: InboundAndReturnFrequency[] = [
  { text: "-", value: 0 },
  { text: "1x per week", value: 1 },
  { text: "2x per week", value: 2 },
  { text: "3x per week", value: 3 },
  { text: "4x per week", value: 4 },
  { text: "1-2x per week", value: 5 },
  { text: "2-3x per week", value: 6 },
  { text: "3-4x per week", value: 7 },
  { text: "4-5x per week", value: 12 },
  { text: "Daily", value: 8 },
  { text: "Monthly", value: 9 },
  { text: "Biweekly", value: 10 },
  { text: "On demand", value: 11 },
];
